const config = {
    api: {
        //baseUrl: "https://goback-api-1070586186100.us-central1.run.app", // Localhost
        //baseUrl: "https://goback-api-648139829704.us-central1.run.app", // AXA Production
        //baseUrl: "https://goback-api-69984414743.us-central1.run.app" // quattro-uat

        baseUrl: process.env.REACT_APP_API_URL || "http://localhost:8080"
    },
    contacts: {
        emailContacto: "info@goback.mx",
        emailSoporte: "info@goback.mx"
    }
}


module.exports = config